var App = App || {};

App.Alerts = (function ($) {
    'use strict';

    function Init() {
        var alerts = $("#Alerts").find(".alert");

        alerts.each(function (index, alert) {
            var $alert = $(alert),
                $alertCollapse = $alert.find(".btn-collapse"),
                guid = $alert.data("guid"),
                cookieName = `Web5_Alert_${guid}`;

            $alertCollapse.on("click", function () {
                var $collapseButton = $(this);

                ToggleCollapse($alert, $collapseButton, cookieName);
                
                // Recalculate heights after collapse/expand animation
                setTimeout(function() {
                    if (typeof App.Masthead !== 'undefined' && typeof App.Masthead.updateHeights === 'function') {
                        App.Masthead.updateHeights();
                    }
                }, 350);
            });

            $alert.on("closed.bs.alert", function () {
                App.Cookies.setItem(cookieName, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
                
                // Recalculate heights after alert is dismissed
                setTimeout(function() {
                    if (typeof App.Masthead !== 'undefined' && typeof App.Masthead.updateHeights === 'function') {
                        App.Masthead.updateHeights();
                    }
                }, 350);
            })
        });
    }

    function ToggleCollapse($alert, $collapseButton, cookieName) {
        if ($collapseButton.attr("aria-expanded") == "false") {
            $collapseButton
                .attr({
                    "aria-expanded": "true",
                    "aria-label": "Collapse alert message"
                });

            $alert
                .removeClass("collapsed")
                .attr("role", "alert");

            App.Cookies.setItem(cookieName, "Collapsable", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
        else {
            $collapseButton.attr({
                "aria-expanded": "false",
                "aria-label": "Expand alert message"
            });

            $alert
                .addClass("collapsed")
                .attr("role", null);

            App.Cookies.setItem(cookieName, "Collapsed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
    }

    return {
        Init: Init
    };

})(jQuery);
